import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedEvent } from "./types";
import { Identifiable, List, Project, Resource } from "@planzone/dto";

function linkEvent(httpClient: HttpClient) {
  return (event: LinkedEvent): Promise<LinkedEvent> =>
    Promise.all([
      httpClient
        .sendHttpRequest<Identifiable<List>>({
          method: HttpMethods.GET,
          endpoint: `/events/${event.uuid}/parentActivity`,
        })
        .then((list) => ({ ...event, list })),
      httpClient
        .sendHttpRequest<Identifiable<Project>>({
          method: HttpMethods.GET,
          endpoint: `/events/${event.uuid}/project`,
        })
        .then((project) => ({ ...event, project })),
      httpClient
        .sendHttpRequest<Identifiable<Resource>>({
          method: HttpMethods.GET,
          endpoint: `/events/${event.uuid}/organizer`,
        })
        .then((organizer) => ({ ...event, organizer })),
      httpClient
        .sendHttpRequest<{
          _embedded: { resources: Identifiable<Resource>[] };
        }>({
          method: HttpMethods.GET,
          endpoint: `/events/${event.uuid}/participants`,
        })
        .then(({ _embedded }) => ({
          ...event,
          participants: _embedded.resources,
        })),
    ]).then((parts) => parts.reduce((e, part) => ({ ...e, ...part }), event));
}

export { linkEvent };
